import axios from "axios";
window.axios = axios;
axios.defaults.withCredentials = false;
axios.defaults.headers.common[
  "Key"
] = `4211859c00a4a9109eafb788c038d3aa54ac477f`;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
// axios.defaults.baseURL = "http://localhost:8006/api/v1/";
axios.defaults.baseURL = "https://fsapi.suzuyagroup.com/api/v1/";
